import {LoginRoutes} from "app/app.types";
import {RouteGC, RouteGCManagement} from "app/services/routeChange/types";

export interface IRouteConfig {
  url: string;
  templateUrl?: string;
  template?: string;
  controller?: string;
  controllerAs?: string;
  abstract?: boolean;
  managerOnly?: boolean;
  parent?: string;
  mode?: string;
}

export interface IRouteState {
  name: string;
  config: IRouteConfig;
}

export interface IHMRConfig {
  name: string;
  url: string;
}

function state(name: string, config: IRouteConfig): IRouteState {
  return { name, config };
}

export const routeList: IRouteState[] = [
  state('setup', {
    url: '/setup::completeState',
    templateUrl: 'app/setup/setup.html',
    controller: 'SetUpCtrl',
    controllerAs: 'setup'
  })
  ,state('browser-warning', {
    url: '/browser-warning',
    templateUrl: 'app/setup/browserWarning.html',
    controller: 'BrowserWarningCtrl',
    controllerAs: 'vm'
  })
  ,state(LoginRoutes.oauth2, {
    url: '/oauth2',
    templateUrl: 'app/login/login.html',
    controller: 'LoginCtrl',
    controllerAs: 'loginCtrl'
  })
  ,state(LoginRoutes.logout, {
    url: '/logout',
    templateUrl: 'app/login/login.html',
    controller: 'LoginCtrl',
    controllerAs: 'loginCtrl'
  })
  ,state(LoginRoutes.login, {
    url: '/login:completeState',
    templateUrl: 'app/login/login.html',
    controller: 'LoginCtrl',
    controllerAs: 'loginCtrl'
  })
  ,state(LoginRoutes.supportLogin, {
    url: '/support-login::accountId::venueId::code',
    templateUrl: 'app/login/login.html',
    controller: 'LoginCtrl',
    controllerAs: 'loginCtrl'
  })
  ,state(LoginRoutes.supportOAuth2Login, {
    url: '/support-oauth2-login::accountId::venueId::jumpFrom',
    templateUrl: 'app/login/login.html',
    controller: 'LoginCtrl',
    controllerAs: 'loginCtrl'
  })
  ,state(LoginRoutes.directLogin, {
    url: '/direct-login::accountId::token',
    templateUrl: 'app/login/login.html',
    controller: 'LoginCtrl',
    controllerAs: 'loginCtrl'
  })
  ,state(LoginRoutes.oauth2DirectLogin, {
    url: '/oauth2-direct-login::accountId::jumpFrom',
    templateUrl: 'app/login/login.html',
    controller: 'LoginCtrl',
    controllerAs: 'loginCtrl'
  })
  ,state(LoginRoutes.adminLogin, {
    url: '/admin-login',
    templateUrl: 'app/login/adminLogin.html',
    controller: 'AdminLoginCtrl',
    controllerAs: 'vm'
  })
  ,state('wizard', {
    url: '/wizard',
    templateUrl: 'app/wizard/wizard.html',
    controller: 'WizardCtrl',
    controllerAs: 'wizardCtrl',
    managerOnly: true
  })

  ///////////////////
  // main
  ///////////////////
  ,state('main', {
    abstract: true,
    url: '',
    template: '<main-menu></main-menu><div ui-view></div><status-info></status-info>'
  })

  ///////////////////
  // bookings
  ///////////////////
  ,state('bookings', {
    url: '/bookings',
    templateUrl: 'app/bookings/bookingsController/bookings.html',
    parent: 'main',
    controller: 'BookingsCtrl',
    controllerAs: 'bookings'
  })

  ///////////////////
  // customers
  ///////////////////
  ,state('customers', {
    url: '/customers',
    templateUrl: 'app/customers/customers.html',
    parent: 'main',
    controller: 'CustomersCtrl',
    controllerAs: 'vm'
  })

  ///////////////////
  // reports
  ///////////////////
  ,state('reports', {
    url: '/reports',
    templateUrl: 'app/reports/reports.html',
    controller: 'ReportsCtrl',
    controllerAs: 'reports',
    parent: 'main',
    managerOnly: true
  }),
  state('reports.overview', {
    url: '/overview',
    parent: 'reports',
    controller: 'OverviewCtrl',
    controllerAs: 'vm',
    templateUrl: 'app/reports/overview/overview.html',
    managerOnly: true
  }),state('reports.bookingsarrivaltimes', {
    url: '/bookingsarrivaltimes',
    controller: 'BookingArrivalTimesCtrl',
    controllerAs: 'vm',
    parent: 'reports',
    templateUrl: 'app/reports/bookingsArrivalTimes/bookings-arrival-times.html',
    managerOnly: true
  }),state('reports.bookings', {
    url: '/bookingsOverTime',
    controller: 'BookingsOverTimeCtrl',
    controllerAs: 'vm',
    parent: 'reports',
    templateUrl: 'app/reports/bookingsOverTime/bookingsOverTime.html',
    managerOnly: true
  }),state('reports.bookingerrors', {
    url: '/bookingerrors',
    controller: 'BookingsErrorsCtrl',
    controllerAs: 'vm',
    parent: 'reports',
    templateUrl: 'app/reports/bookingsErrors/bookingsErrors.html',
    managerOnly: true
  }),state('reports.bookingsize', {
    url: '/bookingsize',
    controller: 'BookingSizeCtrl',
    controllerAs: 'vm',
    parent: 'reports',
    templateUrl: 'app/reports/bookingSize/bookingSize.html',
    managerOnly: true
  }),state('reports.cancelledNoShowBookings', {
    url: '/cancelledNoShowBookings',
    controller: 'CancelledNoShowBookingsCtrl',
    controllerAs: 'vm',
    parent: 'reports',
    templateUrl: 'app/reports/cancelledNoShowBookings/cancelledNoShowBookings.html',
    managerOnly: true
  })
  ,state('reports.forecast', {
    url: '/forecast',
    controller: 'ForecastReportCtrl',
    controllerAs: 'vm',
    parent: 'reports',
    templateUrl: 'app/reports/forecast/forecast.html',
    managerOnly: true
  }),

  ///////////////////
  // Gift Cards
  ///////////////////

  state(RouteGC.name, {
    url: RouteGC.url,
    parent: 'main',
    templateUrl: 'app/gift-cards-v1/giftCardsV1.html',
    controller: 'GiftCardsV1Ctrl',
    controllerAs: 'vm',
    managerOnly: true
  }),
  state(RouteGCManagement.name, {
    parent: RouteGCManagement.parentName,
    url: RouteGCManagement.url,
    controller: 'GCManagementLoaderCtrl',
    controllerAs: 'vm',
    templateUrl: 'app/gift-cards-v1/management-loader/gcManagementLoader.html',
    managerOnly: true
  }),

  ///////////////////
  // staff
  ///////////////////
  ,state('staff', {
    url: '/staff',
    templateUrl: 'app/staff/staff.html',
    parent: 'main',
    controller: 'StaffCtrl',
    controllerAs: 'staff'
  })

  ///////////////////
  // settings
  ///////////////////
  ,state('settings', {
    url: '/settings',
    templateUrl: 'app/settings/settings.html',
    controller: 'SettingsCtrl',
    parent: 'main',
    controllerAs: 'settings',
    managerOnly: true
  })
  ,state('settings.bookings', {
    url: '/bookings',
    parent: 'settings',
    templateUrl: 'app/settings/bookings/bookings.html',
    controller: 'SettingsBookingsCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.sections', {
    url: '/sections',
    parent: 'settings',
    templateUrl: 'app/settings/sections/sections.html',
    controller: 'SectionsCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.sectiongroups', {
    url: '/sectiongroups',
    parent: 'settings',
    templateUrl: 'app/settings/sections/sectionGroups.html',
    controller: 'SectionGroupsCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.servicegroups', {
    url: '/servicegroups',
    parent: 'settings',
    templateUrl: 'app/settings/serviceGroups/serviceGroups.html',
    controller: 'ServiceGroupsCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.floorplan', {
    url: '/floorplan',
    parent: 'settings',
    templateUrl: 'app/settings/floorPlan/floorPlan.html',
    controller: 'FloorPlanCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),
  state('settings.floorplansettings', {
    url: '/floorplansettings',
    parent: 'settings',
    templateUrl: 'app/settings/floorPlanV2/floorPlanSettings.html',
    controller: 'FloorPlanSettingsCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),
  state('settings.layouts', {
    url: '/layouts',
    parent: 'settings',
    templateUrl: 'app/settings/layouts/layouts.html',
    controller: 'LayoutsCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.blockouts', {
    url: '/blockouts',
    parent: 'settings',
    templateUrl: 'app/settings/blockouts/blockouts.html',
    controller: 'BlockOutsCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.blockouts.edit', {
    url: '/blockouts/edit/:id',
    parent: 'settings',
    templateUrl: 'app/settings/blockouts/blockoutEditor.html',
    controller: 'BlockoutEditorCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.menuoptions', {
    url: '/menuoptions',
    parent: 'settings',
    templateUrl: 'app/settings/menuoptions/menuOptionsController/menuOptions.html',
    controller: 'OptionsCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.menuoptions.edit', {
    url: '/menuoptions/edit/:id',
    parent: 'settings',
    templateUrl: 'app/settings/menuoptions/editMenuOption/editMenuOption.html',
    controller: 'MenuOptionEditCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.layouts.edit', {
    url: '/layouts/edit/:id',
    parent: 'settings',
    templateUrl: 'app/settings/layouts/layoutEdit.html',
    controller: 'LayoutEditCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.layouts.duplicate', {
    url: '/layouts/new/:id',
    parent: 'settings',
    templateUrl: 'app/settings/layouts/newLayout.html',
    controller: 'NewLayoutCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.layouts.new', {
    url: '/layouts/new',
    parent: 'settings',
    templateUrl: 'app/settings/layouts/newLayout.html',
    controller: 'NewLayoutCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.events', {
    url: '/events',
    parent: 'settings',
    templateUrl: 'app/settings/events/events.html',
    controller: 'EventsCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.events.edit', {
    url: '/events/edit/:id',
    parent: 'settings',
    templateUrl: 'app/settings/events/eventEditor.html',
    controller: 'EventEditorCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.events.duplicate', {
    url: '/events/duplicate/:id',
    parent: 'settings',
    templateUrl: 'app/settings/events/eventEditor.html',
    controller: 'EventEditorCtrl',
    controllerAs: 'vm',
    managerOnly: true,
    mode: 'duplicate'
  }),state('settings.status', {
    url: '/status',
    parent: 'settings',
    templateUrl: 'app/settings/status/status.html',
    controller: 'StatusCtrl',
    controllerAs: 'vm',
    managerOnly: true
  }),state('settings.schedule', {
    url: '/schedule',
    parent: 'settings',
    templateUrl: 'app/settings/schedule/schedule.html',
    controller: 'ScheduleCtrl',
    controllerAs: 'schedule',
    managerOnly: true
  }),state('settings.schedule.edit', {
    url: '/schedule/edit/:id',
    parent: 'settings',
    templateUrl: 'app/settings/schedule/editSchedule.html',
    controller: 'EditScheduleCtrl',
    controllerAs: 'editSchedule',
    managerOnly: true
  }),state('settings.tableedit', {
    url: '/table/edit/:id',
    parent: 'settings',
    templateUrl: 'app/settings/table/editTable.html',
    controller: 'EditTableCtrl',
    controllerAs: 'editTable',
    managerOnly: true
  }),state('settings.tags', {
    url: '/tags',
    parent: 'settings',
    templateUrl: 'app/settings/tags/tags.html',
    controller: 'TagsCtrl',
    controllerAs: 'vm',
    managerOnly: true
  })
  ,state('settings.layouts.plan', {
    url: '/layouts/:id/plan',
    parent: 'main',
    templateUrl: 'app/plan/plan.html',
    controller: 'TablePlanCtrl',
    controllerAs: 'vm',
    managerOnly: true
  })
  ,state('settings.sections.plan', {
    url: '/sections/plan',
    parent: 'main',
    templateUrl: 'app/plan/plan.html',
    controller: 'SectionsPlanCtrl',
    controllerAs: 'vm',
    managerOnly: true
  })
  ,state('settings.maintenance', {
    url: '/maintenance',
    parent: 'settings',
    templateUrl: 'app/settings/maintenance/maintenance.html',
    controller: 'SettingsMaintenanceCtrl',
    controllerAs: 'vm',
    managerOnly: true
  })
];


